import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpContext } from "@angular/common/http";
import { UrlService } from "../../../environments/urlService";
import { Observable } from "rxjs";
import { InitDataDTO } from "../component/hornavbar/dto/InitDataDTO";
import { IS_SPINNER_ACTIVE } from "../../util/interceptors";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class InitStateBackendService {
  private http = inject(HttpClient);
  private urlService = inject(UrlService);
  private readonly url: string;

  constructor() {
    this.url = this.urlService.getModelsUrl() + 'init-state';
  }

  getInitialData(): Observable<InitDataDTO> {
    return this.http.get<InitDataDTO>(
      this.url + '/data',
      { context: new HttpContext().set(IS_SPINNER_ACTIVE, true), withCredentials: true },
    )
      .pipe(
        map((initData) => InitDataDTO.deserialize(initData))
      );
  }

  updateSession(): Observable<void> {
    return this.http.post<void>(this.url + '/refresh-session', null,
      {
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true,
        responseType: 'json',
      },
    );
  }
}
